import { FC } from 'react';
import DefaultListHeader from './DefaultListHeader';
import DefaultListBody from './DefaultListBody';

const DefaultList: FC = () => (
  <div className="doc-list">
    <DefaultListHeader />
    <DefaultListBody />
  </div>
);

export default DefaultList;
